import { asserts, generators } from '../utils';

const defaultConfig = {
  current: 1,
  pageSize: 20,
  total: 0,
  showQuickJumper: true,
  showSizeChanger: true,
  showTotal: (total) => `共${total}条`,
  pageSizeOptions: ['10', '20', '50', '100', '200', '500'],
};

const paginationCfg = (params) => {
  if (!asserts.isExist(params)) return defaultConfig;
  return {
    ...defaultConfig,
    ...generators.generatorObject(params),
  };
};

export default paginationCfg;
